<template>
  <v-btn-toggle
    :value="value"
    mandatory
    dense
    class="view-toggle"
    :aria-label="ariaLabel || 'View mode selector'"
    :data-testid="dataTestId || 'view-toggle'"
    @change="handleChange"
  >
    <v-btn
      v-for="option in options"
      :key="option.value"
      :value="option.value"
      :aria-label="option.label || option.value"
      :data-testid="`${dataTestId || 'view-toggle'}-${option.value}`"
    >
      <v-icon v-if="option.icon" small>{{ option.icon }}</v-icon>
      <span v-if="option.label && !iconOnly" class="ml-1">{{ option.label }}</span>
    </v-btn>
  </v-btn-toggle>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'

export interface ViewToggleOption {
  value: string
  icon?: string
  label?: string
}

export default Vue.extend({
  name: 'ViewToggle',

  props: {
    /** Current selected value */
    value: {
      type: String,
      required: true
    },
    /** Array of toggle options */
    options: {
      type: Array as PropType<ViewToggleOption[]>,
      required: true,
      validator: (value: ViewToggleOption[]) => {
        return value.length > 0 && value.every(opt => opt.value)
      }
    },
    /** Show only icons (hide labels) */
    iconOnly: {
      type: Boolean,
      default: true
    },
    /** Custom aria-label for accessibility */
    ariaLabel: {
      type: String,
      default: ''
    },
    /** Custom data-testid */
    dataTestId: {
      type: String,
      default: ''
    }
  },

  methods: {
    handleChange(newValue: string) {
      if (newValue !== this.value) {
        this.$emit('input', newValue)
        this.$emit('change', newValue)
      }
    }
  }
})
</script>

<style scoped>
.view-toggle {
  border-radius: var(--radius-sm);
  overflow: hidden;
}

.view-toggle >>> .v-btn {
  border-radius: 0 !important;
  color: #7D8CA3;
}

.view-toggle >>> .v-btn--active {
  background-color: #406A94 !important;
  color: white !important;
}

.view-toggle >>> .v-btn:hover:not(.v-btn--active) {
  background-color: #f5f5f5 !important;
}
</style>
